export default __webpack_public_path__ + "static/media/pageRight.1fea5a76.svg";